import { render } from "./NegociarJa.vue?vue&type=template&id=54144ff8&scoped=true"
import script from "./NegociarJa.vue?vue&type=script&lang=js"
export * from "./NegociarJa.vue?vue&type=script&lang=js"

import "./NegociarJa.vue?vue&type=style&index=0&id=54144ff8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54144ff8"]])

export default __exports__